/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { Upload, Label } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import * as S from './IsOnBoardingSection.styled';
import { creativesActions, formErrorsCampaign_action } from 'store/actions';

const checkIconData = (iconData) => {
  if (!iconData) return '';
  if (iconData.includes('base64')) {
    return iconData;
  } else {
    return `//cdn.appnext.com/banner/${iconData}`;
  }
};

export const IsOnBoardingSection = () => {
  const dispatch = useDispatch();

  const iconUrlOrBase64 = useSelector((state) => state.creatives.selectedCreative?.icon);
  const creativesHavingError = useSelector((state) => state?.formErrorsCampaign.creatives);

  useEffect(() => {
    dispatch(creativesActions.defaultSetOnBoardIcon(iconUrlOrBase64));
    dispatch(
      formErrorsCampaign_action.updateErrorField({ errorField: 'creatives', newValue: false }),
    );
  }, []);

  const onChangeIcon = (selectedFile) => {
    if (!selectedFile) {
      dispatch(
        formErrorsCampaign_action.updateErrorField({ errorField: 'creatives', newValue: true }),
      );
    } else {
      dispatch(
        formErrorsCampaign_action.updateErrorField({ errorField: 'creatives', newValue: false }),
      );
    }
    dispatch(creativesActions.setOnBoardIcon(selectedFile));
  };
  return (
    <S.Box>
      <Label text='App icon:' variant='label' style={{ marginBottom: '8px' }} />
      <S.Container>
        <Upload
          environment='creative'
          maxWidth={null}
          maxHeight={null}
          size={Upload.Size?.Big}
          onChange={onChangeIcon}
          value={checkIconData(iconUrlOrBase64)}
          errorText='icon is required'
          error={creativesHavingError}
        />
      </S.Container>
    </S.Box>
  );
};
